import { getAppConfigSetting, requests } from 'utils';
import { URL } from './constants';

export function detailsRequest(transferId) {
  return requests.get(`${URL(getAppConfigSetting('apiUrl'), transferId)}`);
}



// WEBPACK FOOTER //
// ./src/services/details/api.js